import axios from "axios";
import { message } from "../assets/js/resetMessage";
import Qs from 'qs'
const myaxios = new axios.create({})
//请求拦截器
myaxios.interceptors.request.use((config) => {
  config.headers["X-Requested-With"] = 'XMLHttpRequest'
  let noTokenUrl = ["shop/Login/isToken", "shop/Upload_Log/loginLogError"]//不需要token的请求
  if (!noTokenUrl.includes(config.url)) {
    config.headers.token = localStorage.getItem("token")
  }
  if (config.url == 'shop/User/crowdTotal' || config.url == 'shop/User/addCrowd') {
    config.data = Qs.stringify(config.data)//参数序列化
  }
  config.url = process.env.VUE_APP_PROXY_URL + config.url
  return config
})
// 响应拦截器
myaxios.interceptors.response.use((res) => {
  if (res.status == 200) {
    if (res.data.code == 1) {//成功返回数据
      return Promise.resolve(res.data)
    } else if (res.data.code == 0) {
      if (res.config.url.includes("shop/Crowd/pollingCrowdLog")) {//查看人群发送消息状态
        return Promise.reject(res.data)
      }
      message({
        message: res.data.msg || "未知错误！",
        type: 'warning',
      })
      return Promise.reject(res)
    } else if (res.data.code == 2) {
      let url = res.data.data
      message({
        message: res.data.msg,
        type: 'warning',
        onClose() {
          localStorage.clear()
          sessionStorage.clear()
          setTimeout(() => {
            window.location.href = url;
          }, 1000)
        }
      })
    } else {
      if (res.config.url.includes("shop/pay/add")) {//支付宝支付返回表单数据
        return Promise.resolve(res.data)
      } else {
        return Promise.reject(res)
      }
    }
  } else {
    message({
      message: `${res.status}：未知错误！`,
      type: 'warning'
    })
    return Promise.reject(res);
  }
}, err => {
  if (err.message?.includes("timeout")) {
    message({
      message: "请求超时，请稍后重试！",
      type: 'warning',
    })
    return Promise.reject(err)
  }
  let status = err.request?.status
  if (status > 499) {
    message({
      message: "数据请求失败，请联系客服！",
      type: 'error',
    })
  } else {
    message({
      message: err.message || "未知错误！",
      type: 'error',
    })
  }
  return Promise.reject(err)
})
export default myaxios